import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type { CreateDelegacaoDto, Delegacao, UpdateDelegacaoDto } from '@/types/delegacao';

import { delegacaoService } from './services';

export const listarDelegacoesPorUsuario = createAsyncThunk<Delegacao[], string>(
  'delegacao/listarPorUsuario',
  async (usuarioId, { rejectWithValue }) => {
    try {
      return await delegacaoService.listarPorUsuario(usuarioId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as Delegacao[];
    }
  },
);

export const criarDelegacao = createAsyncThunk<Delegacao, CreateDelegacaoDto>(
  'delegacao/criar',
  async (data, { rejectWithValue }) => {
    try {
      return await delegacaoService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as Delegacao;
    }
  },
);

export const atualizarDelegacao = createAsyncThunk<
  Delegacao,
  { id: string; data: UpdateDelegacaoDto }
>('delegacao/atualizar', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await delegacaoService.atualizar(id, data);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as Delegacao;
  }
});

export const removerDelegacao = createAsyncThunk<string, string>(
  'delegacao/remover',
  async (id, { rejectWithValue }) => {
    try {
      await delegacaoService.remover(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as string;
    }
  },
);
